import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-doctransferencias',
  templateUrl: './main-doctransferencias.component.html',
  styleUrls: ['./main-doctransferencias.component.css']
})
export class MainDoctransferenciasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}


